export default "__VITE_ASSET__BKxPp$tq__"